import {useMutation} from '@tanstack/react-query';

import {postOdontoRebook} from '../../services/postOdontoRebook';

export const usePostOdontoRebookMutation = () => {
	return useMutation({
		mutationFn: postOdontoRebook,
	});
};
